/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-edit-node-if/webhook-edit-node-if.component.scss */
::ng-deep :root {
  --background-element-color: color-mix(in srgb, var(--tem-ink) 10%, transparent);
  --flow-grid-color: color-mix(in srgb, var(--tem-ink) 15%, transparent);
  --selection-area-color: var(--tem-accent-soft);
  --background-group-title-color: var(--tem-surface-2);
  --disabled-color: var(--tem-border);
  --node-background-color: var(--tem-surface);
  --node-background-color-inverse: var(--tem-ink);
  --node-border-radius: var(--tem-radius, 5px);
  --node-border-color: color-mix(in srgb, var(--tem-ink) 28%, var(--tem-surface));
  --node-selected-border-color: var(--tem-accent);
  --node-color: var(--tem-ink);
  --node-shadow: var(--tem-shadow);
  --connection-color: var(--tem-muted);
  --snap-connection-color: color-mix(in srgb, var(--tem-muted) 45%, transparent);
  --connection-gradient-1: var(--tem-danger);
  --connection-gradient-2: var(--tem-success);
  --outlet-color: var(--tem-deep);
  --input-output-color: var(--tem-muted);
  --minimap-background-color: var(--tem-surface);
  --minimap-node-color: var(--tem-muted);
  --minimap-node-selected-color: var(--tem-accent);
  --minimap-view-color: var(--tem-accent-soft);
  --form-field-text-color: var(--node-color);
  --form-field-background: var(--minimap-view-color);
  --form-field-panel-shadow: var(--shadow-4);
  --form-field-panel-background: var(--node-background-color);
  --form-field-active-color: var(--minimap-node-selected-color);
}
::ng-deep .modern-theme {
  --background-element-color: color-mix(in srgb, var(--tem-ink) 10%, transparent);
  --flow-grid-color: color-mix(in srgb, var(--tem-ink) 15%, transparent);
  --selection-area-color: var(--tem-accent-soft);
  --background-group-title-color: var(--tem-surface-2);
  --disabled-color: var(--tem-border);
  --node-background-color: var(--tem-surface);
  --node-background-color-inverse: var(--tem-ink);
  --node-border-radius: var(--tem-radius, 5px);
  --node-border-color: color-mix(in srgb, var(--tem-ink) 28%, var(--tem-surface));
  --node-selected-border-color: var(--tem-accent);
  --node-color: var(--tem-ink);
  --node-shadow: var(--tem-shadow);
  --connection-color: var(--tem-muted);
  --snap-connection-color: color-mix(in srgb, var(--tem-muted) 45%, transparent);
  --connection-gradient-1: var(--tem-danger);
  --connection-gradient-2: var(--tem-success);
  --outlet-color: var(--tem-deep);
  --input-output-color: var(--tem-muted);
  --minimap-background-color: var(--tem-surface);
  --minimap-node-color: var(--tem-muted);
  --minimap-node-selected-color: var(--tem-accent);
  --minimap-view-color: var(--tem-accent-soft);
  --form-field-text-color: var(--node-color);
  --form-field-background: var(--minimap-view-color);
  --form-field-panel-shadow: var(--shadow-4);
  --form-field-panel-background: var(--node-background-color);
  --form-field-active-color: var(--minimap-node-selected-color);
}
::ng-deep .theme-alternate {
  --background-element-color: color-mix(in srgb, var(--tem-ink) 10%, transparent);
  --flow-grid-color: color-mix(in srgb, var(--tem-ink) 15%, transparent);
  --selection-area-color: var(--tem-accent-soft);
  --background-group-title-color: var(--tem-surface-2);
  --disabled-color: var(--tem-border);
  --node-background-color: var(--tem-surface);
  --node-background-color-inverse: var(--tem-ink);
  --node-border-radius: var(--tem-radius, 5px);
  --node-border-color: color-mix(in srgb, var(--tem-ink) 28%, var(--tem-surface));
  --node-selected-border-color: var(--tem-accent);
  --node-color: var(--tem-ink);
  --node-shadow: var(--tem-shadow);
  --connection-color: var(--tem-muted);
  --snap-connection-color: color-mix(in srgb, var(--tem-muted) 45%, transparent);
  --connection-gradient-1: var(--tem-danger);
  --connection-gradient-2: var(--tem-success);
  --outlet-color: var(--tem-deep);
  --input-output-color: var(--tem-muted);
  --minimap-background-color: var(--tem-surface);
  --minimap-node-color: var(--tem-muted);
  --minimap-node-selected-color: var(--tem-accent);
  --minimap-view-color: var(--tem-accent-soft);
  --form-field-text-color: var(--node-color);
  --form-field-background: var(--minimap-view-color);
  --form-field-panel-shadow: var(--shadow-4);
  --form-field-panel-background: var(--node-background-color);
  --form-field-active-color: var(--minimap-node-selected-color);
}
@keyframes pulseStepping {
  0%, 100% {
    box-shadow: 0 0 5px var(--tem-warn);
  }
  50% {
    box-shadow: 0 0 30px var(--tem-warn);
  }
}
@keyframes pulseRunning {
  0%, 100% {
    box-shadow: 0 0 5px var(--tem-success);
  }
  50% {
    box-shadow: 0 0 30px var(--tem-success);
  }
}
.wh-node-status-group {
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(100% - 12px);
  height: 3px;
  background-color: var(--tem-accent);
  margin-left: 6px;
}
.wh-node-status-group.nodraft {
  width: 100%;
  margin-left: 0;
}
.wh-node-name {
  position: absolute;
  width: 100%;
  display: flex;
  height: auto;
  padding-top: 10px;
}
.wh-node-name-text {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-align: center;
  font-weight: 600;
  padding: 5px;
  background-color: color-mix(in srgb, var(--tem-warn) 15%, var(--tem-surface));
  border-radius: 4px;
  border-color: var(--tem-warn);
  border-style: solid;
  border-width: 0.5px;
}
.wh-node-log {
  font-size: 16px;
  position: absolute;
  top: -23px;
  right: 0;
  cursor: pointer;
}
.wh-node-toggle-icon-drag {
  position: absolute;
  right: 0px;
  top: 2px;
  cursor: move;
  font-size: 16px;
  width: 16px;
  height: 16px;
  z-index: 30;
}
.wh-node-activation {
  position: absolute;
  left: 1px;
  bottom: 5px;
  z-index: 30;
}
.debug {
  position: absolute;
  top: -22px;
  z-index: 30;
  font-size: 10px;
  color: var(--tem-danger);
}
.wh-node {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.node-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  height: 100%;
  justify-content: center;
  font-weight: 600;
  z-index: -1;
}
.wh-node-icon {
  position: absolute;
  left: 10px;
  top: 10px;
  cursor: move;
  font-size: 16px;
  width: 16px;
  height: 16px;
  z-index: 30;
  color: var(--node-color);
  transform: rotate(-45deg);
}
.wh-node-title {
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  height: 100%;
  justify-content: center;
  font-weight: 600;
  padding-top: 5px;
}
::ng-deep f-flow .f-connection {
  z-index: 10;
}
::ng-deep f-flow .f-connection .f-connection-drag-handle {
  fill: transparent;
}
::ng-deep f-flow .f-connection .f-connection-selection {
  stroke-width: 10;
}
::ng-deep f-flow .f-connection .f-connection-path {
  stroke: var(--connection-color);
  stroke-width: 3;
}
::ng-deep f-flow .f-connection .f-connection-text,
::ng-deep f-flow .f-connection .f-connection-center {
  fill: var(--connection-color);
  color: var(--connection-color);
  font-weight: 500;
}
::ng-deep f-flow .f-connection.f-snap-connection .f-connection-path {
  stroke: var(--snap-connection-color);
}
::ng-deep f-flow .f-connection.f-selected .f-connection-path {
  stroke: var(--minimap-node-selected-color);
}
::ng-deep f-flow .f-connection:hover {
  stroke: var(--minimap-view-color);
  stroke-width: 6;
  cursor: pointer;
}
.f-node {
  width: 130px;
  height: 80px;
  padding: 24px;
  color: var(--node-color);
  text-align: center;
  background: var(--node-background-color);
  border-radius: var(--node-border-radius);
  border: 1px solid var(--node-border-color);
  cursor: pointer;
  box-shadow: var(--tem-shadow, 0 2px 2px rgba(0, 0, 0, 0.15));
  z-index: 10;
}
.f-node.wh-node-group {
  width: 350px;
  height: 300px;
  background-color: transparent;
  position: absolute;
  z-index: 1;
  overflow: visible;
}
.f-node.wh-node-if {
  width: 130px;
  height: 80px;
}
.f-node.running-class {
  border-color: var(--tem-success) !important;
  border-width: 2px !important;
  border-style: solid !important;
  animation: pulseRunning 2s infinite ease-in-out;
}
.f-node.stepping-class {
  border-color: var(--tem-warn);
  border-width: 2px;
  border-style: solid;
  animation: pulseStepping 2s infinite ease-in-out;
}
.f-node:active {
  box-shadow: var(--node-shadow);
}
.f-node.f-selected {
  box-shadow: var(--node-shadow);
  border-top-color: var(--node-selected-border-color);
  border-right-color: var(--node-selected-border-color);
  border-left-color: var(--node-selected-border-color);
}
.f-node .node-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.f-node-input:not(.f-node),
.f-node-output:not(.f-node) {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--node-border-color);
  background-color: var(--node-background-color);
}
.f-node-input:not(.f-node).left,
.f-node-output:not(.f-node).left {
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
}
.f-node-input:not(.f-node).right,
.f-node-output:not(.f-node).right {
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
}
.f-node-input:not(.f-node).right-top,
.f-node-output:not(.f-node).right-top {
  right: -8px;
  top: 35%;
  transform: translateY(-50%);
  background-color: var(--tem-success);
}
.f-node-input:not(.f-node).right-bottom,
.f-node-output:not(.f-node).right-bottom {
  right: -8px;
  top: 65%;
  transform: translateY(-50%);
  background-color: var(--tem-danger);
}
.f-node-input:not(.f-node).top,
.f-node-output:not(.f-node).top {
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
}
.f-node-input:not(.f-node).top-left,
.f-node-output:not(.f-node).top-left {
  top: -8px;
  left: -8px;
}
.f-node-input:not(.f-node).top-right,
.f-node-output:not(.f-node).top-right {
  top: -8px;
  right: -8px;
}
.f-node-input:not(.f-node).bottom,
.f-node-output:not(.f-node).bottom {
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}
.f-node-input:not(.f-node).bottom-left,
.f-node-output:not(.f-node).bottom-left {
  bottom: -8px;
  left: -8px;
}
.f-node-input:not(.f-node).bottom-right,
.f-node-output:not(.f-node).bottom-right {
  bottom: -8px;
  right: -8px;
}
.f-node-input:not(.f-node).f-node-output-not-connectable,
.f-node-input:not(.f-node).f-node-input-not-connectable,
.f-node-output:not(.f-node).f-node-output-not-connectable,
.f-node-output:not(.f-node).f-node-input-not-connectable {
  background-color: var(--disabled-color);
}
.f-node-input:not(.f-node) {
  border-radius: 4px;
}
.f-resize-handle {
  overflow: visible;
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: var(--node-background-color);
  border: 1px solid var(--node-border-color);
}
.f-resize-handle.f-resize-handle-left-top {
  top: -6px;
  left: -6px;
  cursor: nwse-resize;
}
.f-resize-handle.f-resize-handle-right-top {
  top: -6px;
  right: -6px;
  cursor: nesw-resize;
}
.f-resize-handle.f-resize-handle-left-bottom {
  bottom: -6px;
  left: -6px;
  cursor: nesw-resize;
}
.f-resize-handle.f-resize-handle-right-bottom {
  bottom: -6px;
  right: -6px;
  cursor: nwse-resize;
}
.wh-node-status {
  position: absolute;
  bottom: 0;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: var(--tem-deep-strong);
}
/*# sourceMappingURL=webhook-edit-node-if.component.css.map */
